// extracted by mini-css-extract-plugin
export default {"tooltipWpapper":"TooltipGlobal_tooltipWpapper__xDWj2"};